export default __webpack_public_path__ + "static/media/C2.9173b728.jpg";